import * as React from "react";
import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { classNames } from "../util";
import { graphql, useStaticQuery } from "gatsby";

export default function MainMenu() {
  const data = useStaticQuery(query);
  const menuItems = data.wpMenu.menuItems.nodes as Queries.WpMenuItem[];
  const companyName = data.wpPage.afcPageLogo.companyName;
  const logo = data.wpPage.afcPageLogo.logo;

  const navigation = menuItems.map((menuItem) => {
    return {
      name: menuItem.label,
      href: menuItem.path ?? "#",
      current: false,
    };
  });

  return (
    <Disclosure className="font-['SpaceGrotesk']" as="nav">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
              {logo && <div
                  className="flex flex-shrink-0 items-center cursor-pointer  sm:mr-6"
                  onClick={() => {
                    window.location.href = "/";
                  }}
                >
                  {logo?.sourceUrl && (
                    <img
                      className="block h-4 w-auto lg:hidden"
                      src={logo.sourceUrl}
                    />
                  )}
                  {logo?.sourceUrl && (
                    <img
                      className="hidden h-4 w-auto lg:block"
                      src={logo.sourceUrl}
                    />
                  )}
                  <p className="ml-4 text-white">{companyName}</p>
                </div>}
                <div className="hidden sm:block">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? "bg-gray-900 text-white"
                            : "text-gray-300 hover:bg-gray-700 hover:text-white",
                          "px-3 py-2 rounded-md text-sm font-medium"
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Phone menu */}
          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pt-2 pb-3">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-900 text-white"
                      : "text-gray-300 hover:bg-gray-700 hover:text-white",
                    "block px-3 py-2 rounded-md text-base font-medium"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

export const query = graphql`
  query MainMenu {
    wpMenu(slug: { eq: "main-menu" }) {
      name
      slug
      menuItems {
        nodes {
          label
          path
        }
      }
    }
    wpPage(slug: {eq: "logo-page"}) {
      afcPageLogo {
        companyName
        logo {
          sourceUrl
        }
      }
    }
  }
`;
